import { VALIDATION_MSG, format } from '@geit/helpers';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const buildErrorMessage = _ref => {
  let {
    error,
    rules,
    label
  } = _ref;
  if (!error) {
    return;
  }
  let errorMessage = error.message;
  if (!errorMessage) {
    switch (error.type) {
      case "required":
        errorMessage = VALIDATION_MSG.MANDATORY;
        break;
      case "maxLength":
        errorMessage = VALIDATION_MSG.MAX_LENGTH;
        break;
      case "minLength":
        errorMessage = format(VALIDATION_MSG.MIN_LENGTH, rules == null ? void 0 : rules.minLength);
        break;
      case "max":
        errorMessage = format(VALIDATION_MSG.MAX, label, rules == null ? void 0 : rules.max);
        break;
      case "min":
        errorMessage = format(VALIDATION_MSG.MIN, label, rules == null ? void 0 : rules.min);
        break;
      case "email":
        errorMessage = VALIDATION_MSG.EMAIL;
        break;
      case "nric":
        errorMessage = VALIDATION_MSG.NRIC;
        break;
      case "pattern":
        errorMessage = VALIDATION_MSG.INVALID;
        break;
    }
  }
  return errorMessage;
};
const setMaxLengthPropsAndRules = (rules, maxLength) => {
  if ((rules == null ? void 0 : rules.maxLength) !== void 0 && maxLength === void 0) {
    if (typeof rules.maxLength === "number") {
      maxLength = rules.maxLength;
    } else {
      maxLength = rules.maxLength.value;
    }
  }
  if ((rules == null ? void 0 : rules.maxLength) === void 0 && maxLength !== void 0) {
    if (rules) {
      rules.maxLength = maxLength;
    } else {
      rules = {
        maxLength
      };
    }
  }
  return __spreadProps(__spreadValues({}, {
    rules
  }), {
    maxLength
  });
};
const isRuleValidationRequired = rule => {
  if (rule) {
    if (typeof rule === "boolean") return rule;else if (typeof rule === "string") return true;else return rule.value;
  } else return false;
};
const getRuleValidationMessage = rule => {
  return typeof rule === "boolean" ? void 0 : typeof rule === "string" ? rule : rule == null ? void 0 : rule.message;
};
export { buildErrorMessage, getRuleValidationMessage, isRuleValidationRequired, setMaxLengthPropsAndRules };